<ng-container *ngIf="cabinDetails">

    <div *ngIf="contentfulEditMode && CabinDetails.contentfulEntry" class="contentfulContextEditor contentfulEditingImage">
        <a target="_blank" href="https://app.contentful.com/spaces/xtsdk79cmd4d/entries?contentTypeId={{CabinDetails.contentfulEntry.sys.contentType.sys.id}}&contentTypeHidden=false&order.fieldId=updatedAt&order.direction=descending&displayedFieldIds=updatedAt&displayedFieldIds=author&displayedFieldIds=FHZiAQOdpVpwKgjh&displayedFieldIds=wwLiELFhIEXoHeFx">
            {{cabinDetails.contentfulEntry.sys.contentType.sys.id}}
        </a>
        <span class="contentfulPathSeparator">/</span>
        <a class="contentfulEntryLink" target="_blank" href="https://app.contentful.com/spaces/xtsdk79cmd4d/entries/{{CabinDetails.contentfulEntry.sys.id}}"><strong>{{CabinDetails.contentfulEntry.fields.cabinTypeCode}}</strong></a>
    </div>

    <div class="content">
        <p [innerHtml]="cabinDetails.description | markdown"></p>
    </div>

    <div class="row carrousel">
        <div *ngFor="let img of carrouselWindow(); index as idx" class="column small-6">
            <div *ngIf="idx == 0 && showArrows()" class="prevnext"><a (click)="prev()">&nbsp;</a>&nbsp;</div>
            <div class="imageContainer">
                <img class="carrouselCabinPhoto" [src]="img.fields.file.url">
                <br>&nbsp;
            </div>
            <div *ngIf="idx == 1 && showArrows()" class="prevnext next">&nbsp;<a (click)="next()">&nbsp;</a></div>
        </div>
    </div>

</ng-container>
